import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import RankRow from "@/components/base/RankRow";
import { groups } from "@/mocks/groups";

export default function RankingPreview() {
  const top = [...groups].sort((a, b) => b.score - a.score).slice(0, 8);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20" aria-label="群组排行榜">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="51吃瓜群排行"
          title="群组综合排行榜"
          desc="排行分数由活跃度、管理规范、成员口碑与信息质量综合得出，不只是看人数。完整榜单可在排行页按分类筛选查看。"
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden items-center gap-4 border-b border-background-200 bg-background-100 px-4 py-3 font-label text-xs text-foreground-500 md:flex">
            <span className="w-8 text-center">排名</span>
            <span className="flex-1">群组</span>
            <span className="w-32">活跃度</span>
            <span className="w-14 text-right">推荐指数</span>
          </div>
          {top.map((group) => (
            <RankRow key={group.id} group={group} />
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <Link
            to="/ranking"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            打开完整排行榜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}